<template>
  <div>
    <ul class="feed-list">
      <li class="feed-list__item" v-for="(userFeeds, index) in feeds" :key="index">
        <list-feed-header :user-name="index" @onCollapse="handlerCollapse"/>
        <ul :class="getClass(index)">
          <li v-for="item in userFeeds" :key="item.id">
            <el-tooltip :content="item.threadname" placement="top" effect="light">
              <router-link
                :to="{ name: 'feedAnalytics', params: { threadId: item.id }}"
                class="feed__link"
              >
                {{trimmedTitle(item.threadname)}}
              </router-link>
            </el-tooltip>
            | <span :class="getStatusClass(item.status)">{{getStatus(item.status)}}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import ListFeedHeader from './ListFeedHeader';

  export default {
    name: "feedList",
    props: ['feeds'],
    data() {
      return {
        maxTitleLength: 25,
        pause: "pause",
        activeNames: [],
        threadtype: this.$t('feed.feedType')
      };
    },
    methods: {
      isFeedPaused(status){
        return status !== this.pause;
      },
      trimmedTitle(title) {
        if(title.length > this.maxTitleLength) {
          return title.substring(0, this.maxTitleLength) + "...";
        }
        return title;
      },
      getStatusClass(status) {
        return status === 'pause' ? 'pauseFeed' : 'playFeed';
      },
      getStatus(status) {
        return status === 'pause' ? this.$t('feed.status[0]') : this.$t('feed.status[1]') ;
      },
      handlerCollapse({name, collapse}) {
        if (collapse) {
          this.activeNames.push(name);
        } else {
          this.activeNames = this.activeNames.filter(item => item !== name);
        }
      },
      getClass(name) {
        return !this.activeNames.includes(name) ? 'hide-list' : '';
      }
    },
    components: {
      ListFeedHeader
    }
  };
</script>

<style scoped>
  .feed-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .feed-list__item {
    width: 340px;
    margin-bottom: 20px;
    border: 1px solid #dcdfe6;
    padding: 10px;
    border-radius: 10px;
  }

  .hide-list li{
    display: none;
  }
</style>
